import { useEffect } from "react"
import WPParser from "../lib/parsePage"

export default function WPPageContent({content, props}) {
  useEffect(() => {
    document.dispatchEvent(new CustomEvent('WPContentLoaded'))
  }, [])
  const parsedWP = WPParser.parse(content, props)
  return parsedWP;
}